var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-container" },
    [
      _c(
        "div",
        { staticClass: "hx-breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c("el-breadcrumb-item", [_vm._v("首页")]),
              _c("el-breadcrumb-item", [_vm._v("供应系统")]),
              _c("el-breadcrumb-item", [_vm._v("供应点管理")]),
              _c("el-breadcrumb-item", [_vm._v("核销记录")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "hx-form-container box-shadow" },
        [
          _c(
            "el-form",
            {
              ref: "listParamsForm",
              attrs: {
                rules: _vm.checkListParams,
                model: _vm.listParams,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "领货日期：", prop: "date" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                clearable: "",
                                placeholder: "请选择领货日期",
                                size: "small",
                              },
                              model: {
                                value: _vm.listParams.date,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listParams, "date", $$v)
                                },
                                expression: "listParams.date",
                              },
                            },
                            _vm._l(_vm.dateList, function (item) {
                              return _c("el-option", {
                                key: item.dateId,
                                attrs: {
                                  value: item.dateId,
                                  label: _vm._f("formatDate")(item.date),
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.loadTableData },
                            },
                            [_vm._v(" 查询 ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "hx-table-result",
        {
          attrs: { "page-info": _vm.pager, loading: _vm.tableLoading },
          on: {
            "page-current-change": _vm.handleCurrentChange,
            "page-size-change": _vm.handleSizeChange,
          },
        },
        [
          _c("div", { attrs: { slot: "action" }, slot: "action" }),
          _c("hx-table-result-col", [
            _c("div", { staticClass: "wrap-table-info-display" }, [
              _c(
                "span",
                {
                  staticStyle: {
                    color: "red",
                    "line-height": "32px",
                    "padding-left": "20px",
                  },
                },
                [_vm._v("注：系统将于下一个领货日期前一天晚上11点自动核销")]
              ),
              _c("span", { staticClass: "table-info-display" }, [
                _c("span", [_vm._v("总条数：")]),
                _c("span", { staticClass: "alert-text ft16" }, [
                  _vm._v(_vm._s(_vm.pager.total)),
                ]),
              ]),
            ]),
          ]),
          _c(
            "el-table",
            {
              attrs: {
                slot: "content",
                data: _vm.tableData,
                "max-height": "800",
                border: "",
              },
              slot: "content",
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", width: "60", label: "序号" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(
                              (_vm.pager.pageIndex > 1
                                ? (_vm.pager.pageIndex - 1) * _vm.pager.pageSize
                                : 0) +
                                scope.$index +
                                1
                            ),
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "orderNo", align: "center", label: "订单编号" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.orderNo
                          ? _c("div", [
                              scope.row.orderNo.length > 10
                                ? _c(
                                    "div",
                                    [
                                      _c("el-popover", {
                                        ref: "popover1",
                                        attrs: {
                                          placement: "top-start",
                                          width: "200",
                                          trigger: "hover",
                                          content: scope.row.orderNo,
                                        },
                                      }),
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "popover",
                                              rawName: "v-popover:popover1",
                                              arg: "popover1",
                                            },
                                          ],
                                          staticStyle: { color: "#606266" },
                                          attrs: { type: "text" },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("formatLimitLength")(
                                                  scope.row.orderNo
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _c("div", [
                                    _vm._v(
                                      " " + _vm._s(scope.row.orderNo) + " "
                                    ),
                                  ]),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "mobile", align: "center", label: "手机号" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "goodsTitle",
                  align: "center",
                  label: "菜品名称",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.tradeGoodsList,
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "line-height-style" },
                            [_c("span", [_vm._v(_vm._s(item.goodsTitle))])]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "specTitle", align: "center", label: "规格" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.tradeGoodsList,
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "line-height-style" },
                            [_c("span", [_vm._v(_vm._s(item.specTitle))])]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "quantity", align: "center", label: "数量" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.tradeGoodsList,
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "line-height-style" },
                            [_c("span", [_vm._v(_vm._s(item.quantity))])]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "price", align: "center", label: "价格(元)" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.tradeGoodsList,
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "line-height-style" },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm._f("formatToFixed2")(item.price))
                                ),
                              ]),
                            ]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "status", align: "center", label: "状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.tradeGoodsList,
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "line-height-style" },
                            [
                              item.status === 0
                                ? _c("span", [_vm._v("已完成")])
                                : item.status === 1
                                ? _c("span", [_vm._v("已退货")])
                                : _vm._e(),
                            ]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }